import(/* webpackMode: "eager" */ "/home/runner/work/agger-customer/agger-customer/src/app/global-error.tsx");
